import { z } from 'zod';

export type DigitalCertificateLocalStartPayload = z.infer<typeof digitalCertificateLocalStartPayloadSchema>;
export type DigitalCertificateLocalStartData = z.infer<typeof digitalCertificateLocalStartDataSchema>;
export type DigitalCertificateLocalCompletePayload = z.infer<typeof digitalCertificateLocalCompletePayloadSchema>;
export type DigitalCertificateLocalCompleteData = z.infer<typeof digitalCertificateLocalCompleteDataSchema>;
export type DigitalCertificateCloudProviderData = z.infer<typeof digitalCertificateCloudProviderSchema>;
export type DigitalCertificateCloudDiscoverData = z.infer<typeof digitalCertificateCloudDiscoverDataSchema>;
export type DigitalCertificateCloudCompleteData = z.infer<typeof digitalCertificateCloudCompleteDataSchema>;

export const digitalCertificateLocalStartDataSchema = z.array(
  z.object({
    digestAlgorithmName: z.string(),
    digestAlgorithmOid: z.string(),
    toSignHash: z.string(),
    documentKey: z.string(),
    transferFileId: z.string(),
    version: z.string().nullable(),
  }),
).nonempty();

export const digitalCertificateLocalStartPayloadSchema = z.object({
  certContent: z.string(),
});

export const digitalCertificateLocalCompletePayloadSchema = z.object({
  icpSignatures: z.array(
    z.object({
      documentKey: z.string().nullable(),
      signature: z.string().nullable(),
      transferFileId: z.string().nullable(),
      version: z.string().nullable(),
    }).partial(),
  ),
});

export const digitalCertificateLocalCompleteDataSchema = z.object({
  certificateKey: z.string(),
});

export const digitalCertificateCloudProviderSchema = z.object({
  serviceInfo: z.object({
    service: z.object({
      name: z.string(),
    }),
    provider: z.string(),
    badgeUrl: z.string(),
  }),
  authUrl: z.string(),
});

export const digitalCertificateCloudDiscoverDataSchema = z.object({
  providers: z.array(digitalCertificateCloudProviderSchema),
});

export const digitalCertificateCloudCompleteDataSchema = z.object({
  certificateKey: z.string(),
});
